import styled from 'styled-components';

//freshdesk widget has z 100000 - need to be above it
const CookiePolicyWrapper = styled.div`
  z-index: 100001;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  margin-bottom: 0;
  background-color: #eceeef;
  display: flex;
  ${({ isDesktop }) => (isDesktop ? 'height: 88px; flex-direction: row' : 'height: 177px; flex-direction: column')};
  justify-content: center;
  align-items: center;
`;

export default CookiePolicyWrapper;
